<ui-sidebar-layout
  [navItems]="items()"
  [sidebarEnabled]="isAuthenticated()"
  [showBreadcrumb]="isAuthenticated()"
>
  <ng-template #logo>
    <img
      [src]="links.logoSrc"
      [alt]="links.logoAlt"
      class="max-w-45 max-h-12"
    />
  </ng-template>
  <ng-template #toolbar>
    @if (isAuthenticated()) {
      @if (canUseKasse()) {
        <p-button
          icon="fa-regular fa-cash-register font-bold"
          [text]="true"
          severity="contrast"
          [routerLink]="['/buchungen/tagesdashboard']"
          [pTooltip]="'label.menuTagesdashboard' | translate"
          tooltipPosition="bottom"
        ></p-button>
      }
      <p-button
        icon="fa-regular fa-arrow-right-from-bracket font-bold"
        [text]="true"
        severity="contrast"
        (onClick)="logout()"
      ></p-button>
    }
  </ng-template>
  <ng-template #footer>
    <footer class="bg-surface-100 p-4 mt-auto">
      <div class="">
        <a
          class="nav-item px-3 py-2 text-primary-500 font-bold cursor-pointer"
          [href]="links.impressum"
          target="_blank"
          >{{ 'label.imprint' | translate }}</a
        >
      </div>
    </footer>
  </ng-template>
</ui-sidebar-layout>
